var _sodipodiNamedview, _defs, _g, _g2, _g3, _g4, _g5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBrkfstLogoIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 416.48438,
    zoomAndPan: "magnify",
    viewBox: "0 0 312.36328 312.35938",
    height: 416.47919,
    preserveAspectRatio: "xMidYMid",
    id: "svg38",
    sodipodiDocname: "brkfst-logo-icon.svg",
    inkscapeVersion: "1.3 (0e150ed6c4, 2023-07-21)",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "namedview38",
    pagecolor: "#ffffff",
    bordercolor: "#000000",
    borderopacity: 0.25,
    inkscapeShowpageshadow: 2,
    inkscapePageopacity: 0,
    inkscapePagecheckerboard: "true",
    inkscapeDeskcolor: "#d1d1d1",
    showborder: "true",
    inkscapeZoom: 1.0341667,
    inkscapeCx: 584.52861,
    inkscapeCy: 208.38034,
    "inkscapeWindow-width": 1920,
    "inkscapeWindow-height": 1001,
    "inkscapeWindow-x": -9,
    "inkscapeWindow-y": -9,
    "inkscapeWindow-maximized": 1,
    "inkscapeCurrent-layer": "svg38"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "11f41da5a4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 11.839844,31.320312 H 324.20312 V 343.67969 H 11.839844 Z m 0,0",
    clipRule: "nonzero",
    id: "path1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c44720c631"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 324.20312,187.5 c 0,86.25391 -69.92968,156.17969 -156.17968,156.17969 -86.253909,0 -156.183596,-69.92578 -156.183596,-156.17969 0,-86.25391 69.929687,-156.179688 156.183596,-156.179688 86.25,0 156.17968,69.925778 156.17968,156.179688",
    clipRule: "nonzero",
    id: "path2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5d70f5a330"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 89.933594,83 H 246.11328 V 292 H 89.933594 Z m 0,0",
    clipRule: "nonzero",
    id: "path3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1ed6c4a7dd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 166.26562,83.382812 c -28.28515,0.453126 -76.332026,48.062498 -76.332026,128.152348 0,25.98046 14.019536,80.09375 76.085936,80.09375 60.07031,0 80.09375,-43.29297 80.09375,-80.09375 0,-75.75782 -44.05078,-127.699222 -79.83594,-128.152348",
    clipRule: "nonzero",
    id: "path4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "59af2b0735"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 168.02344,165.53906 H 219 v 51.2461 h -50.97656 z m 0,0",
    clipRule: "nonzero",
    id: "path5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b1b4a0bcd4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 218.31641,216.13672 c 0,-27.76953 -22.51172,-50.28125 -50.28125,-50.28125 v 50.28125 z m 0,0",
    clipRule: "nonzero",
    id: "path6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fdaf29bd8b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 168.02344,216 H 219 v 50.80859 h -50.97656 z m 0,0",
    clipRule: "nonzero",
    id: "path7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1d9855d526"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 168.02344,266.40625 c 27.76953,0 50.28125,-22.51172 50.28125,-50.28125 h -50.28125 z m 0,0",
    clipRule: "nonzero",
    id: "path8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "01e1a54c8d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 117,216 h 51.02344 v 50.80859 H 117 Z m 0,0",
    clipRule: "nonzero",
    id: "path9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "63163ab9b8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 117.72656,216.13672 c 0,27.76953 22.51172,50.28125 50.28125,50.28125 v -50.28125 z m 0,0",
    clipRule: "nonzero",
    id: "path10"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#11f41da5a4)",
    id: "g12",
    transform: "translate(-11.839844,-31.320312)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c44720c631)",
    id: "g11"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2d6bff",
    d: "M 5.742188,25.21875 H 330.30469 v 324.5625 H 5.742188 Z m 0,0",
    fillOpacity: 1,
    fillRule: "nonzero",
    id: "path11"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5d70f5a330)",
    id: "g14",
    transform: "translate(-11.839844,-31.320312)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1ed6c4a7dd)",
    id: "g13"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 5.742188,25.21875 H 330.30469 v 324.5625 H 5.742188 Z m 0,0",
    fillOpacity: 1,
    fillRule: "nonzero",
    id: "path12"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#59af2b0735)",
    id: "g16",
    transform: "translate(-11.839844,-31.320312)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b1b4a0bcd4)",
    id: "g15"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fbd405",
    d: "M 5.742188,25.21875 H 330.30469 v 324.5625 H 5.742188 Z m 0,0",
    fillOpacity: 1,
    fillRule: "nonzero",
    id: "path14"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fdaf29bd8b)",
    id: "g18",
    transform: "translate(-11.839844,-31.320312)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1d9855d526)",
    id: "g17"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2d6bff",
    d: "M 5.742188,25.21875 H 330.30469 v 324.5625 H 5.742188 Z m 0,0",
    fillOpacity: 1,
    fillRule: "nonzero",
    id: "path16"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#01e1a54c8d)",
    id: "g20",
    transform: "translate(-11.839844,-31.320312)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#63163ab9b8)",
    id: "g19"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff5abd",
    d: "M 5.742188,25.21875 H 330.30469 v 324.5625 H 5.742188 Z m 0,0",
    fillOpacity: 1,
    fillRule: "nonzero",
    id: "path18"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrkfstLogoIcon);
export default __webpack_public_path__ + "static/media/brkfst-logo-icon.9cc43222db23988ad41493c3691909b3.svg";
export { ForwardRef as ReactComponent };